import { LeftOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Divider, Input, Spin, Tooltip } from "antd";
import { debounce, uniq } from "lodash";
import { useEffect, useMemo, useRef, useState } from "react";
import { HiRefresh } from "react-icons/hi";
import { IoMenu, IoSearchOutline, IoSearchSharp } from "react-icons/io5";
import { MdDeleteOutline } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { GeneralModal } from "../../../components/modal/GeneralModal";
import { LabelModal } from "../../../components/modal/LabelModal";
import { MemberModal } from "../../../components/modal/MemberModal";
import { MAIL } from "../../../config/Constant";
import { useMenuContext } from "../../../context/MenuContext";
import { useInfoUser } from "../../../store/UserStore";
import { ForwardAllMailModal } from "../../../components/modal/ForwardAllMailModal";
import { DirectoryProvider } from "../../../components/select/directory/DirectoryContext";
import { DraftMailProvider } from "../../../context/DraftMailContext";
import { useUnsavedChangesBlocker } from "../../../hooks/useUnsavedChangesBlocker";
import { MailReply } from "./MailReply";
import { useMailContext } from "../../../context/MailContext";
import { MailMemberModalV2 } from "../../../components/modal/chat/MailMemberModalV2";
import { LuForward } from "react-icons/lu";

const HeaderLeft = () => {
  const { languageMap } = useInfoUser();
  const { selectedConversation, onBackToConversations } = useMenuContext();

  return (
    <div className="left">
      <button onClick={onBackToConversations}>
        <LeftOutlined />
      </button>
      <div className="flex flex-col me-3 w-full">
        <div className="flex gap-[2px] mb-1 font-bold break-all text-[18px]">
          <div className="text-[#2a56b9]">
            {selectedConversation?.isForwardMail &&
              languageMap?.["mail.title.forward"]}
          </div>
          <div className="text-[#2a56b9]">
            {selectedConversation?.forwardConversationId &&
              (languageMap?.["mail.title.forwardAll.svg"] ??
                "[Forward conversation]")}
          </div>
          <div>
            {selectedConversation?.name === "mail.noTitleMail" ||
            !selectedConversation?.name ||
            selectedConversation?.name === ""
              ? languageMap?.["mail.noTitleMail"]
              : selectedConversation?.name}
          </div>
        </div>
      </div>
    </div>
  );
};

const MailDevider = ({ msg, index, isTop }) => {
  const { languageMap } = useInfoUser();

  if (isTop && index === 0) {
    return <div className={`pt-[15px] ${!msg?.isDraft && "pt-[10px]"}`} />;
  }

  if (msg?.forwardLast)
    return (
      <Divider style={{ borderColor: "#2a56b9" }}>
        <div className="flex gap-[2px]">
          <span className="text-[#2a56b9]">
            {languageMap?.["mail.title.forwardAll.svg"] ??
              "[Forward conversation]"}
          </span>
          <span>{languageMap?.[msg?.oldTitle] ?? msg?.oldTitle}</span>
        </div>
      </Divider>
    );

  return <Divider style={{ borderColor: "#e5e7eb" }} />;
};

const HeaderRight = () => {
  const { languageMap } = useInfoUser();
  const { onSearch, refreshMailMessage } = useMenuContext();

  const { setIsOpenModalDeleteConversation, setIsForwardAllMail } =
    useMailContext();

  return (
    <div className="right">
      <Tooltip
        placement="top"
        title={
          languageMap?.["modal.notification.forwardAll.svg"] ??
          "Forward all messages"
        }
        color={"#0091ff"}
      >
        <Button
          className="bg-[#2a56b9] text-[white]"
          onClick={() => setIsForwardAllMail(true)}
          icon={<LuForward className="text-[18px]" />}
        />
      </Tooltip>
      <Tooltip
        placement="bottom"
        title={
          languageMap?.["menu.conversation.searchMessage"] ?? "Search messages"
        }
        color={"#0091ff"}
      >
        <Button
          className="bg-[#2a56b9] text-[white]"
          onClick={onSearch}
          icon={<IoSearchSharp className="text-[18px]" />}
        />
      </Tooltip>
      <Tooltip
        placement="bottom"
        title={languageMap?.["menu.conversation.refresh"] ?? "Refresh"}
        color={"#0091ff"}
      >
        <Button
          className="bg-[#2a56b9] text-[white]"
          onClick={refreshMailMessage}
          icon={<HiRefresh className="text-[18px]" />}
        />
      </Tooltip>
      <Tooltip
        placement="bottom"
        title={languageMap?.["menu.mail.btnDeleteMessage"] ?? "Delete Message"}
        color={"#0091ff"}
      >
        <Button
          className="bg-[#2a56b9] text-[white]"
          onClick={() => setIsOpenModalDeleteConversation(true)}
          icon={<MdDeleteOutline className="text-[18px]" />}
          disabled
        />
      </Tooltip>
    </div>
  );
};

const MailDetail = () => {
  const { languageMap } = useInfoUser();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const recipent = queryParams.get("recipent");

  /** Context */
  const {
    setSelectedConversation,
    selectedConversation,
    handleUpdateConversationList,
    conversationList,
    setIsMenu,
    setLabelSelectedId,
    setIsModalLabelGroup,
    onCloseChatMessage,
    messageSearch,
    setMessageSearch,
    isMessageSearch,
    setIsMessageSearch,
    isModalLabelGroup,
    labelSelectedId,
  } = useMenuContext();

  const {
    topMessageList,
    setTotalNotificationItem,
    bottomMessageList,
    setBottomMessageList,
    setTopMessageList,
    setIsReply,
    setIsMoreMessage,
    totalNotificationItem,
    setTitle,
    cCOrgList,
    setCCOrgList,
    memberOrgList,
    setMemberOrgList,
    onDeleteMessageNotifications,
    onLoadMore,
    isLoading,
    isOpenModalDeleteConversation,
    setIsOpenModalDeleteConversation,
    isForwardAllMail,
    setIsForwardAllMail,
    isModalMembersReadUnread,
    setIsModalMembersReadUnread,
    selectedMessage,
    setSelectedMessage,
  } = useMailContext();

  const inputSearchRef = useRef(null);
  const [listMember, setListMember] = useState([]);
  const [isReplyAll, setIsReplyAll] = useState(false);

  const [openModalShowMember, setOpenModalShowMember] = useState(false);
  const notificationRepliesRef = useRef(null);
  const bottomMessagesRef = useRef(null);

  const [isSendingSuccess, setIsSendingSuccess] = useState(false);

  const mailReplyRefs = useRef({});
  const [dirtyMap, setDirtyMap] = useState({});

  const handleDirtyChange = (id, dirty) =>
    setDirtyMap((prev) => ({ ...prev, [id]: dirty }));

  const isDirty = Object.values(dirtyMap).some(Boolean);

  const {
    isOpenModalNotifyChange,
    handleSaveAndLeave,
    handleDiscardAndLeave,
    handleUpdateScheduleAndLeave,
    handleCancelLeave,
  } = useUnsavedChangesBlocker({
    isDirty,
    onSave: async () => {
      for (const reply of Object.values(mailReplyRefs.current)) {
        await reply?.saveDraft?.();
      }
    },
    onDiscard: () => {
      setDirtyMap({});
    },
    onUpdateSchedule: async () => {
      for (const reply of Object.values(mailReplyRefs.current)) {
        await reply?.updateSchedule?.();
      }
    },
  });

  const handleCancelModalShowMember = () => {
    setOpenModalShowMember(false);
  };

  const addMemberOrg = () => {
    let userIds = memberOrgList
      ?.filter((org) => org?.type === "PERSON" && org?.checked)
      ?.map((org) => org?.objectId);
    userIds = uniq(userIds);

    let ccIds = cCOrgList
      ?.filter((org) => org?.type === "PERSON" && org?.checked)
      ?.map((org) => org?.objectId);
    ccIds = uniq(ccIds);

    return { userIds, ccIds };
  };

  const showLoadMoreIcon = useMemo(() => {
    if (
      totalNotificationItem - MAIL.BOTTOM_MESSAGE - MAIL.TOP_MESSAGE > 0 &&
      totalNotificationItem -
        topMessageList?.length -
        bottomMessageList?.length >
        0
    ) {
      return (
        <div className="flex flex-col items-center pt-[10px]">
          <button
            className="rounded-[50%] border-[1px] border-[#cccccc] w-[36px] p-[7px]"
            onClick={onLoadMore}
          >
            {totalNotificationItem - MAIL.BOTTOM_MESSAGE - MAIL.TOP_MESSAGE > 99
              ? "99+"
              : totalNotificationItem -
                topMessageList?.length -
                bottomMessageList?.length}
          </button>
        </div>
      );
    }
  }, [
    selectedConversation,
    totalNotificationItem,
    topMessageList?.length,
    bottomMessageList?.length,
  ]);

  const scrollToTop = () => {
    if (notificationRepliesRef.current) {
      notificationRepliesRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    setTitle(selectedConversation?.type ? selectedConversation?.name : "");
    setListMember([]);
    setIsMoreMessage(false);
    setIsReply(false);
    setCCOrgList([]);
    setMemberOrgList([]);
    setIsMessageSearch(false);
  }, [selectedConversation?.conversationId]);

  useEffect(() => {
    if (isMessageSearch) {
      inputSearchRef?.current.focus();
    }
  }, [isMessageSearch]);

  useEffect(() => {
    if (bottomMessagesRef.current && isSendingSuccess) {
      bottomMessagesRef.current.scrollIntoView({ behavior: "instant" });
      setIsSendingSuccess(false);
    }
  }, [isSendingSuccess]);

  useEffect(() => {
    if (recipent && cCOrgList?.length > 0) {
      const updatedList = cCOrgList?.map((item) => ({
        ...item,
        checked: false,
      }));
      setCCOrgList(updatedList);
    }
    setTitle("");
  }, [recipent]);

  return (
    <div className="flex overflow-hidden flex-1 bg-[#f5f5f5]">
      <div className="chat-content h-[100vh]">
        <div className="header sticky top-0 z-50 bg-white shadow-md">
          <HeaderLeft />
          <button
            className="icon menu-icon"
            onClick={() => {
              setIsMenu(true);
            }}
          >
            <IoMenu size={25} />
          </button>
          <HeaderRight
            isReplyAll={isReplyAll}
            notificationRepliesRef={notificationRepliesRef}
          />
        </div>
        <div className="search-message">
          {isMessageSearch && (
            <div className="flex justify-center items-center p-3">
              <Input
                ref={inputSearchRef}
                placeholder={
                  languageMap?.["messageList.search.placeholder"] ??
                  "Search Message"
                }
                onChange={debounce((e) => {
                  setMessageSearch({
                    ...messageSearch,
                    content: e.target.value,
                  });
                }, 500)}
                prefix={<IoSearchOutline size={15} />}
                allowClear
                className="mr-1"
              />
              <Button
                className="font-bold font-[16px]"
                type="text"
                onClick={onCloseChatMessage}
              >
                {languageMap?.["app.close"] ?? "Close"}
              </Button>
            </div>
          )}
        </div>
        <div
          className="chat-body w-full h-[100%] bg-white border-y overflow-y-auto overflow-y-scroll-email"
          ref={notificationRepliesRef}
        >
          {topMessageList?.map((msg, index) => {
            const isLastItem = index === topMessageList?.length - 1;
            return (
              <div key={msg?.letterId} className="">
                {/*<MailDevider msg={msg} index={index} isTop={true} />*/}
                <DraftMailProvider
                  letterId={msg?.letterId}
                  senderId={msg?.senderId}
                  replyMessage={msg}
                >
                  <MailReply
                    ref={(el) => {
                      if (el) mailReplyRefs.current[msg.mailId] = el;
                      else delete mailReplyRefs.current[msg.mailId];
                    }}
                    notification={msg}
                    isLastItem={isLastItem}
                    isTopMessage={true}
                    setIsSendingSuccess={setIsSendingSuccess}
                    setIsReplyAll={setIsReplyAll}
                    setTotalNotificationItem={setTotalNotificationItem}
                    addMemberOrg={addMemberOrg}
                    listMember={listMember}
                    setSelectedMessage={setSelectedMessage}
                    setIsModalMembersReadUnread={setIsModalMembersReadUnread}
                    onSentSuccess={scrollToTop}
                    onDirtyChange={(dirty) =>
                      handleDirtyChange(msg.mailId, dirty)
                    }
                  />
                </DraftMailProvider>
              </div>
            );
          })}

          {/* open up */}
          {showLoadMoreIcon}

          {bottomMessageList?.map((msg, index) => {
            if (msg?.isDraft === true) return <></>;
            const isLastItem = index === bottomMessageList?.length - 1;

            return (
              <div key={msg?.letterId}>
                <MailDevider msg={msg} />
                <DraftMailProvider
                  letterId={msg?.letterId}
                  senderId={msg?.senderId}
                  replyMessage={msg}
                >
                  <MailReply
                    ref={(el) => {
                      if (el) mailReplyRefs.current[msg.mailId] = el;
                      else delete mailReplyRefs.current[msg.mailId];
                    }}
                    notification={msg}
                    isLastItem={isLastItem}
                    topMessageList={topMessageList}
                    setTopMessageList={setTopMessageList}
                    bottomMessageList={bottomMessageList}
                    setBottomMessageList={setBottomMessageList}
                    isTopMessage={false}
                    listMember={listMember}
                    setIsSendingSuccess={setIsSendingSuccess}
                    setTotalNotificationItem={setTotalNotificationItem}
                    addMemberOrg={addMemberOrg}
                    setSelectedMessage={setSelectedMessage}
                    setIsModalMembersReadUnread={setIsModalMembersReadUnread}
                    onSentSuccess={scrollToTop}
                    onDirtyChange={(dirty) =>
                      handleDirtyChange(msg.mailId, dirty)
                    }
                  />
                </DraftMailProvider>
              </div>
            );
          })}

          <div ref={bottomMessagesRef} />
          <div className="mb-[80px]" />
        </div>
        {isLoading && (
          <div className="relative bottom-[50%] left-[50%]">
            <Spin
              indicator={<LoadingOutlined className="text-[35px]" spin />}
            />
          </div>
        )}
      </div>
      {/* <SideBarMail isOpen={isMenu} onClose={() => setIsMenu(false)} /> */}
      {isOpenModalNotifyChange && (
        <GeneralModal
          title={languageMap?.["modal.draft.title"] ?? "Save draft?"}
          content={
            languageMap?.["modal.draft.content"] ??
            "You have unsaved changes. Do you want to save this as a draft before leaving?"
          }
          open={isOpenModalNotifyChange}
          onConfirm={handleSaveAndLeave}
          onDiscard={handleDiscardAndLeave}
          onUpdateSchedule={handleUpdateScheduleAndLeave}
          updateScheduleText="Update Schedule"
          onCancel={handleCancelLeave}
          confirmText="Save"
          discardText="Discard"
          cancelText="Cancel"
        />
      )}
      {isModalLabelGroup && (
        <LabelModal
          labelSelectedId={labelSelectedId}
          setLabelSelectedId={setLabelSelectedId}
          handleUpdateConversationList={handleUpdateConversationList}
          conversationList={conversationList}
          isModalLabelOpen={isModalLabelGroup}
          setIsModalLabelOpen={setIsModalLabelGroup}
          selectedConversation={selectedConversation}
          setSelectedConversation={setSelectedConversation}
          bottomMessagesRef={bottomMessagesRef}
        />
      )}
      {openModalShowMember && (
        <DirectoryProvider>
          <MemberModal
            selectedConversation={selectedConversation}
            openModalShowMember={openModalShowMember}
            handleCancelModalShowMember={handleCancelModalShowMember}
          />
        </DirectoryProvider>
      )}
      {isModalMembersReadUnread && (
        <MailMemberModalV2
          letterId={selectedMessage?.letterId}
          onCancel={() => setIsModalMembersReadUnread(false)}
          isOpen={isModalMembersReadUnread}
          oldConversationId={selectedMessage?.oldConversationId}
        />
      )}

      {isOpenModalDeleteConversation && (
        <GeneralModal
          title={
            languageMap?.["modal.confirm.titleDeleteMessage"] ??
            "Are you sure you want to delete the message notifications?"
          }
          content={
            languageMap?.["modal.confirm.contentDeleteMessage"] ??
            "Once deleted, the messages will be gone permanently."
          }
          open={isOpenModalDeleteConversation}
          onConfirm={onDeleteMessageNotifications}
          onCancel={() => setIsOpenModalDeleteConversation(false)}
        />
      )}
      {isForwardAllMail && (
        <ForwardAllMailModal
          isForwardAllMail={isForwardAllMail}
          setIsForwardAllMail={setIsForwardAllMail}
          addMemberOrg={addMemberOrg}
        />
      )}
    </div>
  );
};

export { MailDetail };
